import { z } from 'zod'

export const classroomReferrerSchema = z.enum(['home', 'lesson-list', 'booking', 'reserved', 'ai-home'])

export const classroomUrlParamsSchema = z.object({
  classId: z.number(),
  level: z.number().optional(),
  week: z.number().optional(),
  permission: z.enum(['true', 'false']).optional(),
  langType: z.enum(['EN', 'JP', 'KR', 'ENJP']).optional(),
  sessionId: z.string().optional(),
  referrer: classroomReferrerSchema.optional(),
  originals: z.record(z.string(), z.string().or(z.number()).optional()).optional(),
})

export type ClassroomParams = z.infer<typeof classroomUrlParamsSchema>
